// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryPage_container__bdbxO","pagination":"CategoryPage_pagination__VGfFw"};